// NOTE: to change these, also update backend routes in client_urls.py
export const URLS = {
  ADMIN: '/admin',
  BOARD_DETAIL: '/board/:id',
  DASHBOARD: '/dashboard',
  USER_SETTINGS: '/user-settings',
  ORG_SETTINGS: '/org-settings',
  HOME: '/',
  LOGIN: '/slack/oauth/login/link/',
  LOGOUT: '/auth/logout',
  ORGANIZATION_DETAIL: '/organization/:id',
  SLACK_INSTALL: '/slack/install',
  SLACK_INSTALL_DENIED: '/slack/install/denied',
  SLACK_INSTALL_THANKS: '/slack/install/thanks',
  SLACK_LOGIN_DENIED: '/slack/login/denied',
  SLACK_LOGIN_SUCCESS: '/slack/login/success',
  QUESTION_DETAIL: '/question/:id',
  MATT: '/matt',
}

export const MAX_TITLE_LENGTH = 100 // The page title max size
export const QUESTIONS_ORDER_RECENT = ['-created', '-upvotes']
export const QUESTIONS_ORDER_UPVOTED = ['-upvotes', '-created']

export const AVATAR_SIZE = 48 // in px

export const DEFAULT_GROWTH_PLAN_ID = 'jelly-growth-1'
export const DEFAULT_GROWTH_PLAN_COST = '49'



// WEBPACK FOOTER //
// ./src/constants.js